<template>
<div>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title mb-4 text-muted">Dibawah ini terdapat {{filterItems(dataList).length}} anggota yang terdaftar dikelas.</h4>
                    <div class="d-flex">
                        <div class="flex-grow-1 mb-4">
                            <input type="text" class="form-control border-muted" placeholder="Cari member berdasarkan nomor induk atau nama disini ..." v-model="searchQuery">
                        </div>
                        <div class="flex-shrink-0">
                            <button type="button" class="btn ms-2" @click="deleteBatch()" :class="{'btn-secondary': selectedId.length == 0, 'btn-danger': selectedId.length > 0}" :disabled="selectedId.length == 0"><i class="mdi mdi-delete me-2"></i>Hapus Terpilih</button>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-centered table-nowrap mb-0">
                            <thead>
                                <tr>
                                    <th style="width: 50px;">
                                        <div class="form-check">
                                            <input type="checkbox" class="form-check-input" style="transform: scale(1.5);" id="customCheckall" v-model="checkAll" @change="selectAllData()" :checked="selectedId.length > 0">
                                            <label class="form-check-label" for="customCheckall"></label>
                                        </div>
                                    </th>
                                    <th>Nomor Induk</th>
                                    <th>Nama</th>
                                    <th>Role</th>
                                    <th>Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in filterItems(dataList)" :key="row.id">
                                    <td>
                                        <div class="form-check" v-if="!row.is_coordinator">
                                            <input type="checkbox" class="form-check-input" id="customCheck1" style="transform: scale(1.5);" @change="selectData(row.member_id)" :checked="selectedId.indexOf(row.member_id) != -1">
                                            <label class="form-check-label" for="customCheck1"></label>
                                        </div>
                                    </td>
                                    <td width="15%">{{row.identity_number}}</td>
                                    <td>{{row.name}}</td>
                                    <td width="15%">
                                        <span class="badge bg-primary me-2" v-if="row.role == 'teacher'">Guru</span>
                                        <span class="badge bg-info me-2" v-if="row.role == 'student'">Siswa</span>
                                    </td>
                                    <td width="15%">
                                        <button type="button" class="btn btn-outline-danger btn-sm" @click="deleteData(row)" v-if="!row.is_coordinator">Hapus</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- end card-body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->
    </div>
</div>
</template>
<script>
export default {
    name: 'Member',
    metaInfo: {
        title: "Daftar Anggota",
        titleTemplate: "%s - Elearning"
    },
    data() {
        return {
            selectedId: [],
            checkAll: false,
            dataFetch: false,
            searchQuery: '',
            dataList: []
        }
    },
    created() {
        this.getData()
    },
    methods: {
        selectAllData: function () {
            if (this.checkAll) {
                this.dataList.forEach(element => {
                    if (!element.is_coordinator)
                        this.selectData(element.member_id)
                });
            } else {
                this.selectedId = []
            }
        },
        selectData: function (id) {
            if (this.selectedId.indexOf(id) != -1)
                this.selectedId.splice(this.selectedId.indexOf(id), 1)
            else
                this.selectedId.push(id)
        },
        getData: function () {
            let uri = process.env.VUE_APP_APIHOST + 'teacher/courses/list-member';

            this.dataFetch = true;
            this.$http.get(uri, {params: {courses_id: this.$route.params.id}}).then(res => {
                this.dataFetch = false;
                this.dataList = res.data.data;
            });
        },
        deleteData: function (data) {
            this.$swal({
                icon: 'info',
                title: 'Apa apa kamu yakin ?',
                text: 'Kamu akan menghapus data dengan nama ' + data.name,
                showCancelButton: true,
                confirmButtonText: 'Hapus',
                cancelButtonText: 'Batal',
            }).then((result) => {
                if (result.value) {
                    this.$http.post(process.env.VUE_APP_APIHOST + 'teacher/courses/delete-member', {
                            id: data.member_id,
                        })
                        .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.getData();
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                        })
                }
            });
        },
        deleteBatch: function () {
            this.$swal({
                icon: 'info',
                title: 'Apa apa kamu yakin ?',
                text: 'Kamu akan menghapus ' + this.selectedId.length + ' data yang terpilih',
                showCancelButton: true,
                confirmButtonText: 'Hapus',
                cancelButtonText: 'Batal',
            }).then((result) => {
                if (result.value) {
                    this.$http.post(process.env.VUE_APP_APIHOST + 'teacher/courses/delete-member-batch', {
                            list_id: this.selectedId,
                        })
                        .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.selectedId=[];
                                        this.getData();
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                        })
                }
            });
        },
        filterItems: function (data) {
            var app = this;
            return data.filter(function (result) {
                let regex = new RegExp('(' + app.searchQuery + ')', 'i');
                return result.identity_number.toString().match(regex) || result.name.match(regex);
            })
        }
    },
}
</script>